module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDVIMFYxM0gxN1Y1WiIgZmlsbD0iIzFFMzM1NCIvPgo8cGF0aCBkPSJNMCA0VjBIOC4zVjEuNzc4SDE3VjRIMFoiIGZpbGw9IiMxRTMzNTQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon-file.svg
// module id = wx2c
// module chunks = 0